import {
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { Fragment } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { formatDatetime } from "../../../../actions/util";
import {
  KhungNoiDungsEndpoint,
  PhienHopsEndpoint,
  ThanhPhanThamDusEndpoint,
} from "../../../../service/Meet";
import Vertical from "./VerticalNoiDung/Vertical";
import Content from "./VerticalNoiDung/Content";
import {
  Enum_Meeting_Status,
  _Enum_Trang_Thai_Noi_Dung,
  _Enum_Trang_Thai_Tham_Du,
} from "../../../action/defaultEnums";
import StreamMeeting from "./VerticalNoiDung/StreamMeeting";
import Meeting from "./VerticalNoiDung/StreamMeeting/Meeting";
import { Action, ActionText, compare } from "./DangKyPhatBieu";
import FormAttachFile from "./FormAttachFile";
import { TOKEN_CLIENT_INFO } from "../../../../actions/constants";
import {
  CHECK_CONFIRM,
  CHECK_ERROR,
  CHECK_TIME,
} from "../../../../components/alert/Alert";
import { forwardRef } from "react";
import DrawerDocument from "./DrawerDocument";
import { AccountsEndpoint } from "../../../../service/Admin";
import { useDispatch } from "react-redux";
import {
  actionIsChuTri,
  actionIsUBND,
  actionPhienHop,
  actionThanhPhanThamDu,
} from "../Redux/ActionsMeeting";
import { useSelector } from "react-redux";
import ButtonMate from "@mui/material/Button";
import SpeechToText from "./SpeechToText";
import {
  Button,
  Divider,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FontAwesome } from "../../../../components/icon";
import LogActivity from "./LogActivity";
import { RenderPDF } from "./NoiDung";
import { useAsync } from "../../../../hooks";
import { Main as MainGateWay } from "../../../../service/GateWay";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";

export const cumulativeOffset = function (element) {
  var top = 0;
  do {
    top += element.offsetTop || 0;
    element = element.offsetParent;
  } while (element);
  return top;
};
const useStyles = makeStyles((theme) => ({
  root: { padding: "3px" },
  icon: { minWidth: "2rem" },
  text: { color: "green" },
  share: { color: "orange" },
}));

// eslint-disable-next-line no-unused-vars
const MenuMeet = memo(
  ({
    setShowDocDraw,
    setOpenSpeechToText,
    phienHopId,
    isDienBien,
    isChuTri,
    handleEndMeeting,
    setShowLogActivity,
  }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [shareScreen, setShareSreen] = useState(null);
    const { phienHop } = useSelector((state) => state.meetingRProcess);
    const [openReportPDF, setOpenReportPDF] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const openReportKetLuanPhienHop = useCallback(async (data) => {
      try {
        const file = await PhienHopsEndpoint.reportPDFKetLuanPhienHop(data);
        const url = window.URL.createObjectURL(file);
        setOpenReportPDF(url);
        return true;
      } catch (error) {
        throw new Error(error);
      }
    }, []);

    const { status, execute: exportReportMeet } = useAsync(
      openReportKetLuanPhienHop,
      false,
    );
    return (
      <>
        <ButtonMate onClick={handleClick}>
          <FontAwesome
            style={{ fontSize: "x-large" }}
            fa="ellipsis"
          ></FontAwesome>
        </ButtonMate>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {/* <ListItem button onClick={() => {
                    setShowDocDraw(true);
                    setAnchorEl(null);
                }}>
                    <ListItemIcon className={classes.icon}>
                        <Icon color="secondary" fontSize="small">file_copy</Icon>
                    </ListItemIcon>
                    <ListItemText primary="Tài liệu phiên họp" />
                </ListItem>
                <Divider /> */}
            <ListItem
              button
              onClick={() => {
                setShowLogActivity(phienHopId);
                setAnchorEl(null);
              }}
            >
              <ListItemIcon className={classes.icon}>
                <Icon color="secondary" fontSize="small">
                  history
                </Icon>
              </ListItemIcon>
              <ListItemText primary="Diễn biến phiên họp" />
            </ListItem>
            {phienHop && phienHop.trangThai !== Enum_Meeting_Status.KetThuc && (
              <>
                <Divider />
                {/* <ListItem button onClick={() => {
                            setShareSreen(true);
                            setAnchorEl(null);
                        }}>
                            <ListItemIcon className={classes.icon}>
                                <Icon className={classes.share} color="secondary" fontSize="small">screen_share_outlined</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Chia sẽ màn hình" />
                        </ListItem>
                        <Divider /> */}
                {/* <ListItem button onClick={() => {
                            setOpenSpeechToText(phienHopId)
                            setAnchorEl(null)
                        }}>
                            <ListItemIcon className={classes.icon}>
                                <Icon style={{ color: 'green' }} fontSize="small">check_circle</Icon>
                            </ListItemIcon>
                            <ListItemText primary="Kết luận" />
                        </ListItem> */}
                {!isDienBien && isChuTri && (
                  <>
                    <Divider />
                    <ListItem
                      button
                      onClick={() => {
                        setAnchorEl(null);
                        handleEndMeeting(phienHopId);
                      }}
                    >
                      <ListItemIcon className={classes.icon}>
                        <Icon color="primary" fontSize="small">
                          assignment_turned_in
                        </Icon>
                      </ListItemIcon>
                      <ListItemText primary="Kết thúc phiên họp" />
                    </ListItem>
                  </>
                )}
              </>
            )}
            <Divider />
            <ListItem
              button
              onClick={() => exportReportMeet({ id: phienHopId })}
            >
              <ListItemIcon className={classes.icon}>
                {status === "pending" ? (
                  <span className="d-flex">
                    Đang tải file <div className="spinner-notify" />
                  </span>
                ) : (
                  <Icon color="secondary" fontSize="small">
                    assessment
                  </Icon>
                )}
              </ListItemIcon>
              <ListItemText primary="Biên bản cuộc họp" />
            </ListItem>
          </List>
        </Popover>
        <Modal
          isOpen={shareScreen}
          toggle={() => {
            setShareSreen(null);
          }}
          className={"modal-lg"}
        >
          <ModalHeader> Chia sẽ màn hình </ModalHeader>
          <ModalBody>
            {/* {shareScreen &&
                    // <ShareScreen {...{ phienHopId }} />
                    <SignalR {...{ phienHopId }}></SignalR>
                } */}
          </ModalBody>
        </Modal>
        <RenderPDF url={openReportPDF} onClose={() => setOpenReportPDF(null)} />
      </>
    );
  },
);

const Main = forwardRef(
  ({ phienHopId, handleClose, isDienBien, nameAgent }, ref) => {
    const [tabActive, setTabActive] = useState({ activeTab: 0, id: null });
    const [isShowStream, setIsShowStream] = useState(false);
    const refMeet = useRef();
    const [showDocDraw, setShowDocDraw] = useState(false);
    const [showLogActivity, setShowLogActivity] = useState(null);
    const [openSpeechToText, setOpenSpeechToText] = useState(null);
    const [urlPDF, setUrlPDF] = useState(null);

    const { isChuTri, thamDus, phienHop } = useSelector(
      (state) => state.meetingRProcess,
    );
    const refContent = useRef();
    const refFormFile = useRef();
    const dispatch = useDispatch();

    const endStream = useCallback(() => {
      refContent.current && refContent.current.endStream();
    }, []);

    const handleExit = useCallback(async () => {
      if (
        TOKEN_CLIENT_INFO?.role === "TGH" &&
        phienHop.trangThai === Enum_Meeting_Status.DangHop
      ) {
        const thamDu =
          thamDus &&
          thamDus.thamGia.find(
            (cur) => cur.nhanSuId === TOKEN_CLIENT_INFO.nhanSuId,
          );
        try {
          await ThanhPhanThamDusEndpoint.updateThamDus(thamDu.id, {
            diemDanh: false,
          });
        } catch (error) {
          console.log(error);
          console.log("Lỗi kết nối!");
        }
      }
    }, [phienHop, thamDus]);

    useImperativeHandle(ref, () => ({
      endStream,
      setOpenSpeechToText,
      handleExit,
    }));

    const getThamDu = useCallback(
      async (id) => {
        const { value: thamDus } =
          await ThanhPhanThamDusEndpoint.getFullWithPhienHopId(id);
        const { resultObj: duocDiThay } =
          await PhienHopsEndpoint.getDuocDiThay(id);
        //get avatar
        const userIds = [];
        thamDus.forEach((ns) => ns.nhanSu && userIds.push(ns.nhanSu.userId));
        const { resultObj: urlCanBos } = await AccountsEndpoint.getUrlAvatars(
          userIds,
          { noLoading: true },
        );
        // check UBND
        if (TOKEN_CLIENT_INFO.khachMoiId) {
          dispatch(actionIsUBND(false));
        } else {
          const curThamDu = thamDus.find(
            (cur) => cur.nhanSuId === TOKEN_CLIENT_INFO.nhanSuId,
          );
          if (!curThamDu?.isGuest || TOKEN_CLIENT_INFO?.role === "QLH") {
            dispatch(actionIsUBND(true));
          } else {
            const { resultObj } = await PhienHopsEndpoint.CheckUBND(id);
            dispatch(actionIsUBND(resultObj));
          }
        }
        //-----Vang-ThamDu------
        const thamGia = thamDus.filter(
          (cur) => cur.trangThaiThamDu === _Enum_Trang_Thai_Tham_Du.ThamGia,
        );
        thamGia.forEach((cur, i, arr) => {
          const exist = duocDiThay.find((dt) => dt.id === cur.parentId);
          if (exist) arr[i]["diThayCho"] = exist;
        });
        const vang = thamDus.filter(
          (cur) =>
            [
              _Enum_Trang_Thai_Tham_Du.ThamGia,
              _Enum_Trang_Thai_Tham_Du.DiThay,
            ].includes(cur.trangThaiThamDu) === false,
        );
        let { nhanSuId, khachMoiId } = TOKEN_CLIENT_INFO;
        nhanSuId = nhanSuId === "" ? null : nhanSuId;
        khachMoiId = khachMoiId === "" ? null : khachMoiId;
        const userThamDu = thamDus.find(
          (cur) =>
            cur[nhanSuId ? "nhanSuId" : "khachMoiId"] ===
            (nhanSuId || khachMoiId),
        );
        return { thamGia, vang, userThamDu, urlCanBos };
      },
      [dispatch],
    );

    const updateDataThamDu = useCallback(
      async (id) => {
        const dataThamDu = await getThamDu(id);
        dispatch(actionThanhPhanThamDu(dataThamDu));
        return true;
      },
      [dispatch, getThamDu],
    );

    const getPhienHop = useCallback(
      async (id) => {
        try {
          const phienHop = await PhienHopsEndpoint.getAllData(id);
          const { khungNoiDungs } = phienHop;
          khungNoiDungs.sort(compare);
          phienHop["khungNoiDungs"] = khungNoiDungs;
          const activeNoiDung = khungNoiDungs.findIndex(
            (cur) => cur.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop,
          );
          const dataThamDu = await getThamDu(id);
          dispatch(actionPhienHop(phienHop));
          dispatch(actionThanhPhanThamDu(dataThamDu));
          dispatch(
            actionIsChuTri(
              [
                phienHop.chuTriId,
                phienHop.thuKyId,
                phienHop.chuyenVienId,
              ].includes(TOKEN_CLIENT_INFO?.nhanSuId),
            ),
          );
          if (activeNoiDung > -1)
            setTabActive({
              activeTab: activeNoiDung + 1,
              id: khungNoiDungs[activeNoiDung].id,
            });
          if (isDienBien)
            setTabActive({ activeTab: 1, id: khungNoiDungs[0].id });
        } catch (error) {
          console.log(error);
        }
      },
      [dispatch, getThamDu, isDienBien],
    );

    useEffect(() => {
      if (phienHopId) {
        getPhienHop(phienHopId);
      }
    }, [getPhienHop, phienHopId]);

    const { name, batDau, ketThuc, khungNoiDungs } = phienHop || {};

    const ListCanBo = ({ canBos, isThamGia }) => {
      return (
        canBos && (
          <Table size="sm" bordered striped className="mb-0">
            <thead>
              <tr
                style={{ background: "rgb(0, 111, 202)" }}
                className="text-white"
              >
                <td className="text-center">STT</td>
                <td style={{ minWidth: "9rem" }} className="text-center">
                  Họ và tên
                </td>
                <td className="text-center">Chức danh</td>
                {isThamGia && (
                  <>
                    <td className="text-center">Đi thay cho</td>
                  </>
                )}
              </tr>
            </thead>
            <tbody className="position-sticky overflow-auto">
              {canBos &&
                canBos.map((cb, i) => {
                  const { nhanSu, khachMoi, diThayCho } = cb;
                  return (
                    <tr key={i}>
                      <Action>{i + 1}</Action>
                      <ActionText>
                        {nhanSu
                          ? nhanSu?.thongTinCaNhan?.hoVaTenDem +
                            ` ` +
                            nhanSu?.thongTinCaNhan?.ten
                          : khachMoi?.name}
                      </ActionText>
                      <ActionText>
                        {nhanSu ? nhanSu?.chucDanh?.name : khachMoi?.about}
                      </ActionText>
                      {isThamGia && (
                        <>
                          <ActionText>{diThayCho?.hoVaTen}</ActionText>
                        </>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )
      );
    };

    const finishMeet = useCallback(
      async (phienHopId) => {
        try {
          if (tabActive.id) {
            await KhungNoiDungsEndpoint.update(tabActive.id, {
              trangThai: _Enum_Trang_Thai_Noi_Dung.HoanThanh,
            });
          }
          await PhienHopsEndpoint.updateData(phienHopId, {
            trangThai: Enum_Meeting_Status.KetThuc,
          });
          await CHECK_TIME(
            "Phiên họp kết thúc",
            "Quay về danh sách phiên họp",
            () => {},
          );
          if (typeof handleClose === "function") {
            handleClose();
          }
        } catch (error) {
          CHECK_ERROR("Thao tác thất bại");
        }
      },
      [handleClose, tabActive],
    );

    const setActiveNextNoiDung = useCallback(
      async (idPreNoiDung, isNext = true, arrNoiDung) => {
        const { khungNoiDungs } = phienHop;
        const indexPre = khungNoiDungs.findIndex(
          (cur) => cur.id === idPreNoiDung,
        );
        if (indexPre > -1) {
          // tìm nội dung tiếp theo
          const activeNoiDung = isNext
            ? khungNoiDungs[indexPre + 1]
            : khungNoiDungs[indexPre];
          if (activeNoiDung) {
            //cập nhật danh sách nội dung hiện tại
            phienHop.khungNoiDungs = arrNoiDung;
            setTabActive({ activeTab: indexPre + 1, id: idPreNoiDung });
          } else {
            finishMeet(phienHopId);
          }
        }
        return;
      },
      [phienHop, finishMeet, phienHopId],
    );

    // eslint-disable-next-line no-unused-vars
    const handleEndMeeting = useCallback(() => {
      CHECK_CONFIRM("Chắc chắn kết thúc phiên họp?").then((res) => {
        if (res && res.isConfirmed) finishMeet(phienHopId);
      });
    }, [finishMeet, phienHopId]);

    useEffect(() => {
      const a = document.getElementById("content-vertical");
      if (a) {
        a.style.height = window.screen.availHeight - cumulativeOffset(a) - 120;
      }
    }, []);

    const onClickPDF = useCallback((viewPDF, isCaNhan) => {
      const url = MainGateWay.getDocUrlByPath(viewPDF.path);
      setUrlPDF(url);
    }, []);

    const renderDocumentTreeFile = useMemo(() => {
      return (
        <DrawerDocument
          isOpen={showDocDraw}
          onClose={() => setShowDocDraw(false)}
        >
          <div
            className="text-center text-white p-1 bg-blue position-sticky"
            style={{ top: "0px" }}
          >
            <h2>Tài liệu phiên họp</h2>
          </div>
          <FormAttachFile
            // notPopup={true}
            onClickPDF={onClickPDF}
            showDocDraw={showDocDraw}
            ref={refFormFile}
            id={phienHopId}
            phienHopId={phienHopId}
            TEndpoint={PhienHopsEndpoint}
            isTree={true}
          />
        </DrawerDocument>
      );
    }, [onClickPDF, phienHopId, showDocDraw]);

    // eslint-disable-next-line no-unused-vars
    const handleStream = useCallback(() => {
      setIsShowStream(true);
      // const driver = new webdriver.Builder().forBrowser("chrome").build();
      // // Instantiate a web browser page
      // driver.navigate().to("Yahoo")
      //     .then(() => driver.findElement(By.css("#login-username")))
      //     .then(element => element.getAttribute("value"))
      //     .then(value => console.log(value));
      // const until = webdriver.until; // useful utility to wait command
      // const By = webdriver.By; // useful Locator utility to describe a query for a WebElement
      // driver.navigate().to("Yahoo")
      //     .then(() => driver.findElement(By.css('#login-username')).sendKeys('xyz@yahoo.com'))
      //     .then(() => driver.wait(until.elementLocated(By.css('#login-signin'))))
      //     .then(() => driver.findElement(By.css('#login-signin')).click())
    }, []);

    const renderLogActivity = useMemo(() => {
      return (
        <LogActivity
          isOpen={showLogActivity}
          close={() => {
            setShowLogActivity(null);
          }}
        ></LogActivity>
      );
    }, [showLogActivity]);

    return (
      <Fragment>
        {/* Modern Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            backgroundColor: "#ffffff",
            padding: "16px 24px",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          {/* Left Section - Title & Info */}
          <Box sx={{ flex: 1 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mb: 0.5 }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: "#1f2937",
                  fontSize: "20px",
                }}
              >
                {name}
              </Typography>
              {phienHop?.trangThai === Enum_Meeting_Status.DangHop && (
                <Box
                  sx={{
                    backgroundColor: "#fef2f2",
                    color: "#dc2626",
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "4px 10px",
                    borderRadius: "4px",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Đang diễn ra
                </Box>
              )}
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ color: "#6b7280", fontSize: "13px" }}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon sx={{ fontSize: "16px" }}>schedule</Icon>
                <Typography sx={{ fontSize: "13px" }}>
                  {formatDatetime(batDau)} - {formatDatetime(ketThuc)}
                </Typography>
              </Stack>
              {phienHop?.phongHop?.name && (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Icon sx={{ fontSize: "16px" }}>location_on</Icon>
                  <Typography sx={{ fontSize: "13px" }}>
                    {phienHop.phongHop.name}
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Box>

          {/* Right Section - Actions */}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              sx={{
                color: "#374151",
                borderColor: "#d1d5db",
                textTransform: "none",
                fontSize: "13px",
                "&:hover": {
                  borderColor: "#9ca3af",
                  backgroundColor: "#f9fafb",
                },
              }}
              startIcon={
                <Icon sx={{ fontSize: "18px !important" }}>folder_open</Icon>
              }
              onClick={() => setShowDocDraw(true)}
            >
              Tài liệu
            </Button>
            {(isChuTri || TOKEN_CLIENT_INFO.mainRole === "TK") && (
              <Button
                onClick={() => setOpenSpeechToText(phienHopId)}
                size="small"
                variant="outlined"
                sx={{
                  color: "#374151",
                  borderColor: "#d1d5db",
                  textTransform: "none",
                  fontSize: "13px",
                  "&:hover": {
                    borderColor: "#9ca3af",
                    backgroundColor: "#f9fafb",
                  },
                }}
                startIcon={
                  <Icon sx={{ fontSize: "18px !important" }}>check_circle</Icon>
                }
              >
                Kết luận
              </Button>
            )}
            {/* <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#3b82f6",
                color: "#ffffff",
                textTransform: "none",
                fontSize: "13px",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#2563eb",
                  boxShadow: "none",
                },
              }}
              startIcon={
                <Icon sx={{ fontSize: "18px !important" }}>
                  record_voice_over
                </Icon>
              }
            >
              Đăng ký phát biểu
            </Button> */}
            <MenuMeet
              {...{
                setShowDocDraw,
                setShowLogActivity,
                setOpenSpeechToText,
                handleEndMeeting,
                isChuTri,
                phienHopId,
              }}
            />
          </Stack>
        </Box>

        {/* Hidden components that are still needed */}
        {renderDocumentTreeFile}
        {renderLogActivity}
        <SpeechToText
          {...{ phienHopId, nameAgent, isChuTri }}
          isOpen={openSpeechToText}
          onClose={() => setOpenSpeechToText(null)}
        />
        <Vertical
          id="content-vertical"
          tabWidth={400}
          value={tabActive.activeTab}
          onClick={(dataTab) => {
            setTabActive(dataTab);
          }}
          tabs={khungNoiDungs || []}
        >
          {tabActive && tabActive.id ? (
            <Content
              index={tabActive.activeTab}
              ref={refContent}
              setTabActive={setTabActive}
              title="Nội dung chi tiết"
              phienHopId={phienHopId}
              khungNoiDungId={tabActive.id}
              handleClose={handleClose}
              isDienBien={isDienBien}
              setActiveNextNoiDung={setActiveNextNoiDung}
              updateDataThamDu={updateDataThamDu}
            />
          ) : (
            <div className="sprinter-bg">
              <div className="spinner-2"></div>
            </div>
          )}
        </Vertical>
        {/* {urlPDF && (
          <FullScreenDialog
            open={urlPDF ? true : false}
            onClose={() => setUrlPDF(null)}
          >
            <PDFViewer
              height={
                phienHopId ? "calc(100vh - 120px)" : "calc(100vh - 231px)"
              }
              fileUrl={urlPDF}
            />
          </FullScreenDialog>
        )} */}
        {isShowStream && (
          <StreamMeeting close={() => setIsShowStream(false)}>
            <Meeting ref={refMeet}>
              {/* {
                            tabActive && <Vertical
                                height={450}
                                tabWidth={400}
                                value={tabActive.activeTab}
                                onChange={(event, newValue) => { setTabActive(newValue) }}
                                tabs={khungNoiDungs || []}
                            >
                                <Content isView={true}
                                setTabActive={setTabActive}
                                title="Nội dung chi tiết"
                                phienHopId={phienHopId}
                                khungNoiDungId={tabActive} />
                            </Vertical>
                        } */}
              <iframe
                width="100%"
                height="100%"
                src={"https://mcu.veda.vn:8443/webrtc/call.html"}
                title={"streamVideo"}
                frameBorder="0"
                allow="camera *;microphone *"
                allowFullScreen
              />
            </Meeting>
          </StreamMeeting>
        )}
      </Fragment>
    );
  },
);
export default Main;
